import { createBrowserHistory, createHashHistory } from 'history';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'semantic-ui-css/semantic.min.css';
import Root from './containers/Root';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/configureStore';
import routes from './router/routes';

export const store = configureStore();

const renderReactDOM = (history) => {
  Sentry.init({
    dsn: 'https://5ae855d4c1d840c1b06679123069574f@sentry.io/1335198'
  });

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<Root store={store} history={history} />);

  registerServiceWorker();

  if (module.hot) {
    module.hot.accept();
  }
};

if (window.cordova) {
  document.addEventListener(
    'deviceready',
    () => {
      renderReactDOM(createHashHistory());

      if (window.cordova.platformId == 'ios' && window.plugins && window.plugins.impacTracking) {
        window.plugins.impacTracking.canRequestTracking((canRequest) => {
          if (canRequest) {
            window.plugins.impacTracking.requestTracking(
              null,
              (granted) => {
                if (granted) {
                  window.trackingAllowed = true;
                } else {
                  window.trackingAllowed = false;
                }
              },
              (error) => {
                console.error("Error requesting tracking:", error);
              }
            );
          }
        });
      }

      if (!window.handleOpenURL) {
        window.handleOpenURL = function (url) {
          let base = window.cordova.platformId == 'ios' ? 'app://localhost/index.html#/' : 'https://localhost/index.html#/';
          const path = url.replace("monsyn://", "");

          if (path.includes('dashboard') || path == '') {
            window.location = base;
            return;
          }

          routes.forEach(route => {
            if (route.path == `/${path}`) {
              window.location = base + path;
            }
          })

          return;
        }
      }
    },
    false
  );
} else {
  renderReactDOM(createBrowserHistory());
}
